import { Injectable } from '@angular/core';
import { FunctionsService } from '../__common/functions.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../__config/config.service';

@Injectable({
  providedIn: 'root'
})

export class ShopifyService {

  userId = 999;

  constructor(private commonFunctions: FunctionsService,private http: HttpClient,private configService: ConfigService) {
  }

  buyProduct(obj){
    let baseUrl = '';
    //obj.user_id? this.userId = obj.user_id : null;
    
    let productId = this.commonFunctions.smartFind(this.configService.getStockProductsFromShopify(),obj.productVariantId);
    if(productId && productId.variantId){
      baseUrl = this.getShopifyCheckoutUrl(productId.variantId,1);
      window.open(baseUrl,'__blank');
    }else{
      console.log('ERROR: No variant ID found in switch @shopifyService');
      //this.guiFlow.openSimpleSnackBar('Error, contacta con el admin','error',null,'');
    }
  }

  getShopifyCheckoutUrl(variantId, quantity: number): string {
    return `https://60481f-11.myshopify.com/cart/${variantId}:${quantity}?attributes[user_id]=${this.userId}&attributes[order_token]=${this.commonFunctions.getCurrentToken()}`;
  }
}
